import { IS_SYNTHETIC_TEST } from 'utils/queryParamHelpers';

export function baseEligibilityCheck() {
  const ineligibilities = {
    isSynth:
      window.Cypress ||
      navigator.userAgent.indexOf('DatadogSynthetics') > -1 ||
      IS_SYNTHETIC_TEST,
  };

  return !Object.values(ineligibilities).some(meetsIneligibility => {
    return meetsIneligibility;
  });
}
